/**
 * Populates #modalQuickView from a product's /products/{handle}.js JSON endpoint
 * when a .js-quick-view trigger is clicked. Keeps the modal generic (works for any
 * product) without needing a server round-trip per open beyond this one JSON fetch.
 */
(function () {
  'use strict';

  var modal = document.querySelector('[data-quick-view-modal]');
  if (!modal) return;

  var moneyFormat = (window.themeVars && window.themeVars.moneyFormat) || '${{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  var state = { product: null, selectedVariant: null };

  function render(product) {
    state.product = product;
    state.selectedVariant = product.variants[0];

    modal.querySelector('[data-quick-view-title]').textContent = product.title;
    modal.querySelector('[data-quick-view-full-details]').setAttribute('href', product.url);

    var imagesWrap = modal.querySelector('[data-quick-view-images]');
    imagesWrap.innerHTML = '';
    (product.images.length ? product.images : [product.featured_image]).forEach(function (src) {
      if (!src) return;
      var slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.innerHTML = '<div class="item"><img loading="lazy" width="591" height="714" src="' + src + '" alt="' + escapeHtml(product.title) + '"></div>';
      imagesWrap.appendChild(slide);
    });
    var swiperEl = modal.querySelector('[data-quick-view-swiper]');
    if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
    if (window.Swiper) {
      swiperEl.swiper = new window.Swiper(swiperEl, {
        navigation: { nextEl: '.single-slide-next', prevEl: '.single-slide-prev' },
        pagination: { el: '.al-sw-pagination', clickable: true }
      });
    }

    renderVariant();

    var option = product.options && product.options[0];
    var optionsWrap = modal.querySelector('[data-quick-view-options]');
    if (option && product.variants.length > 1) {
      optionsWrap.style.display = '';
      modal.querySelector('[data-quick-view-option-name]').textContent = option.name + ':';
      var buttonsWrap = modal.querySelector('[data-quick-view-option-buttons]');
      buttonsWrap.innerHTML = '';
      option.values.forEach(function (value) {
        var variant = product.variants.find(function (v) { return v.option1 === value; });
        var btn = document.createElement('span');
        btn.className = 'size_btn text-body-s fw-normal' + (variant === state.selectedVariant ? ' active' : '');
        btn.textContent = value;
        btn.setAttribute('data-value', value);
        if (!variant || !variant.available) btn.classList.add('disabled');
        btn.addEventListener('click', function () {
          if (!variant) return;
          state.selectedVariant = variant;
          buttonsWrap.querySelectorAll('.size_btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          modal.querySelector('[data-quick-view-option-value]').textContent = value;
          renderVariant();
        });
        buttonsWrap.appendChild(btn);
      });
    } else {
      optionsWrap.style.display = 'none';
    }
  }

  function renderVariant() {
    var variant = state.selectedVariant;
    modal.querySelector('[data-quick-view-price]').textContent = formatMoney(variant.price);
    var compareEl = modal.querySelector('[data-quick-view-compare-price]');
    var badgeEl = modal.querySelector('[data-quick-view-badge]');
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareEl.textContent = formatMoney(variant.compare_at_price);
      compareEl.style.display = '';
      var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
      badgeEl.textContent = 'Save ' + pct + '%';
      badgeEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
      badgeEl.style.display = 'none';
    }
    var addBtn = modal.querySelector('[data-quick-view-add-to-cart]');
    if (variant.available) {
      addBtn.removeAttribute('disabled');
      addBtn.setAttribute('data-variant-id', variant.id);
      addBtn.textContent = (window.themeStrings && window.themeStrings.addToCart) || 'Add To Cart';
    } else {
      addBtn.setAttribute('disabled', 'disabled');
      addBtn.removeAttribute('data-variant-id');
      addBtn.textContent = 'Sold out';
    }
    var wishlistBtn = modal.querySelector('[data-quick-view-wishlist]');
    if (wishlistBtn) {
      wishlistBtn.setAttribute('data-product-id', state.product.id);
      wishlistBtn.setAttribute('data-product-handle', state.product.handle);
      if (window.themeWishlist) {
        var active = window.themeWishlist.has(state.product.id);
        wishlistBtn.classList.toggle('addwishlist', active);
        var icon = wishlistBtn.querySelector('.icon');
        if (icon) {
          icon.classList.toggle('icon-Hearth', !active);
          icon.classList.toggle('icon-HearthFill', active);
        }
      }
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.js-quick-view');
    if (!trigger) return;
    var card = trigger.closest('[data-product-handle]');
    var handle = card ? card.getAttribute('data-product-handle') : null;
    if (!handle) return;
    e.preventDefault();
    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(render)
      .catch(function () {});
  });

  var qtyInput = modal.querySelector('[data-quick-view-qty]');
  modal.addEventListener('click', function (e) {
    if (e.target.closest('.btn-decrease')) {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      return;
    }
    if (e.target.closest('.btn-increase')) {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      return;
    }
    var buyBtn = e.target.closest('[data-quick-view-buy-now]');
    if (buyBtn && state.selectedVariant && state.selectedVariant.available && window.themeCart) {
      window.themeCart.buyNow(state.selectedVariant.id, parseInt(qtyInput.value, 10) || 1, buyBtn);
      return;
    }
    var addBtn = e.target.closest('[data-quick-view-add-to-cart]');
    if (addBtn && !addBtn.hasAttribute('disabled') && window.themeCart) {
      var variantId = addBtn.getAttribute('data-variant-id');
      var qty = parseInt(qtyInput.value, 10) || 1;
      window.themeCart.addToCart(variantId, qty, addBtn);
    }
  });
})();
